import { getCookie } from './utils/cookies';
import { isPasswordProtectionEnabled } from './utils/environment';
import { prependLocaleToPath } from './utils/localization';
export const passwordLockCookie = 'uid_session';
export const passwordLockFormUrl = '/pages/password-lock';
export const passwordLockSessionId = 'mcglf2qvhxnwov9prny1h8cmz9hr36ipq3uvncm67ip';

export const isPasswordProtectionEnabledInEnv = (shop: string) => {
  return ['devaloyoga.myshopify.com', 'dev2aloyoga.myshopify.com', 'uataloyoga.myshopify.com'].includes(shop);
};

export const checkHasDevServerAccess = () => {
  if (
    isPasswordProtectionEnabled &&
    isPasswordProtectionEnabledInEnv(window.Shopify.shop) &&
    !window?.Shopify?.designMode
  ) {
    var myCookieValue = getCookie(passwordLockCookie);
    if (myCookieValue !== passwordLockSessionId) window.location.href = prependLocaleToPath(passwordLockFormUrl);
  }
};
